import axios from "axios";
import { getStore } from "app/configureStore";
import env from "app/utils/env";
import { FETCH_HOTEL_ONLY_FILTERS } from "app/pages/HotelOnly/HotelOnlyActionTypes";

export const FETCH_HOTELS = "FETCH_HOTELS";
export const FETCH_HOTELS_REQUEST = "FETCH_HOTELS_REQUEST";
export const FETCH_HOTELS_SUCCESS = "FETCH_HOTELS_SUCCESS";
export const FETCH_HOTELS_FAILURE = "FETCH_HOTELS_FAILURE";

export const fetchHotels = quotationPayload => {
	return {
		type: FETCH_HOTELS,
		// TODO: Modify with real API URL /quote to implement in envVar file
		promise: axios.post("http://localhost:9000/hotelonly/quote", {
			...quotationPayload,
		}),
	};
};
export const fetchHotelOnlySearchFormAvailability = () => {
	const state = getStore().getState();
	const shop = state.shop;
	const endpoint = env("CONTENT_API_URL") || env("BASE_URL");

	return {
		type: FETCH_HOTEL_ONLY_FILTERS,
		promise: axios.get(
			`${endpoint}/${state.productsVisibility}/${shop}/hypnos/hotel_destinations.json`
		),
	};
};
